<template>
	<FileManager
		ref="fileManager"
		:service="fileService"
		:prefix="id"
		accept=".pdf"
		v-bind="{
			selected,
			submitted,
		}"
		v-slot="{
			browse,
			canMerge,
			deleted,
			empty,
			loading,
			merge,
			merging,
			prefix,
			refresh,
			renamed,
			results,
			listSubmitResult,
			uploading,
			uploadPercent,
			zip,
			zipping,
			myAllResult,
			
		}"
		@loaded="filesLoaded"
		@merged="mergedDocuments"
		@zipped="zippedDocuments"
		@error="fileError($event)"
	>
		<b-row class="d-flex align-items-center">
			<b-col cols="4" lg="6" xl="4" class="mb-3 mt-4 text-left">
				<b-button-group>
					<!-- <b-button
						variant="secondary"
						@click="toggleList"
						:disabled="loading || uploading"
						class="px-2 px-lg-4 mr-2 ml-3"
						style="padding-right:2px;"
						v-if="previewing"
					>
						<span v-if="showList"><|</span>
						<span v-else>|></span>
					</b-button> -->

					<b-button
						variant="light"
						@click="browse"
						:disabled="loading || uploading"
						title="Upload"
						class="px-2 px-lg-4 btn btn-outline-primary"
					>
						<font-awesome-icon icon="cloud-upload-alt" fixed-width class="mr-2" />
					</b-button>

					<b-button v-if="showRefresh" variant="light" @click="refresh" :disabled="loading" title="Refresh">
						<font-awesome-icon icon="refresh" fixed-width :spin="loading" />
						<span class="sr-only">Refresh</span>
					</b-button>
				</b-button-group>
			</b-col>
			<b-col cols="8" lg="6" xl="8" class="mb-3 mt-4 text-right">
				<transition name="fade" mode="out-in">
					<div v-if="selected.length > 0" class="mr-3">
						<b-button
							variant="info"
							@click="merge(selected)"
							:disabled="merging || !canMerge"
							title="Create a combined PDF file from multiple source files"
							v-if="selected.length > 1"
						>
							<font-awesome-icon icon="file-pdf" fixed-width />
							Merge PDFs
						</b-button>

						<b-button
							variant="info"
							@click="zip(selected)"
							:disabled="zipping"
							title="Create a .zip archive of selected files"
						>
							<font-awesome-icon icon="file-zipper" fixed-width />
							Zip Files
						</b-button>
					</div>
				</transition>
			</b-col>
		</b-row>
		<b-row v-if="previewing" class="d-flex">
			<b-col cols="12" class="my-2">
			<div class="horizontal-scroll-container">
				<b-form-checkbox-group v-model="selected" name="selected">
				<b-list-group :flush="flush" class="horizontal-scroll-list">
					<transition-group name="fade" mode="out-in" tag="div" class="d-flex flex-row">
					<div v-for="(result, index) in [...myAllResult, ...listSubmitResult]" :key="result.path || result.filename" class="d-flex flex-row">
						<FileManagerItem
						v-if="result.path"
						:prefix="prefix"
						:service="fileService"
						:value="result"
						ref="fileItems"
  						:ref-in-for="true"
						v-slot="{
							canDelete,
							canDownload,
							canPreview,
							canRename,
							deleting,
							destroy,
							download,
							extension,
							fileName,
							isDirectory,
							lastModified,
							lastModifiedTimeAgo,
							mimeType,
							name,
							previewUrl,
							rename,
							renaming,
							size
						}"
						@deleted="deleted"
						@error="fileError($event)"
						@renamed="renamed"
						>
						<b-list-group-item :disabled="deleting" :active="previewUrl == previewingUrl">
							<b-row>
							<b-col cols="12" class="d-flex align-items-center">
								<b-form-checkbox :value="fileName" class="mr-2" />
								<div v-if="deleting">Deleting...</div>
								<div v-else-if="!isDirectory" class="d-flex align-items-center">
								<a
									href="#"
									v-if="canPreview"
									@click.prevent="previewFile(fileName, previewUrl)"
									class="font-weight-bold"
									:title="`${name}\n${size}\n${lastModified.toLocaleDateString()}`"
									:class="{ 'text-white': previewUrl == previewingUrl, 'text-dark': previewUrl !== previewingUrl }"
								>
									{{ name.substring(0, 12) }}
								</a>
								</div>
							</b-col>
							</b-row>
						</b-list-group-item>
						</FileManagerItem>
						
						<FileManagerSubmitPacket
						v-else-if="result.filename"
						:prefix="prefix"
						:service="fileService"
						:value="result"
						v-slot="{
							canDelete,
							canDownload,
							canPreview,
							canRename,
							deleting,
							destroy,
							download,
							extension,
							fileName,
							isDirectory,
							lastModified,
							lastModifiedTimeAgo,
							mimeType,
							name,
							previewUrl,
							rename,
							renaming,
							size,
							displayName,
						}"
						@deleted="deleted"
						@error="fileError($event)"
						@renamed="renamed"
						>
						<b-list-group-item :disabled="deleting" :active="previewUrl === previewingUrl" :style="{ backgroundColor: '#FFC7ED'}">
							<b-row>
							<b-col cols="12" class="d-flex align-items-center">
								<b-form-checkbox :value="fileName + '~PacketSubmit'" class="mr-2" />
								<div v-if="deleting">Deleting...</div>
								<div v-else-if="!isDirectory" class="d-flex align-items-center">
								<a
									href="#"
									v-if="canPreview"
									@click.prevent="previewFile(fileName, previewUrl)"
									class="font-weight-bold"
									 :title="`${name || 'Unknown'}\n${size || 'Unknown size'}\n${lastModified ? new Date(lastModified).toLocaleDateString() : 'Unknown date'}`"
									:class="{ 'text-dark': previewUrl === previewingUrl, 'text-dark': previewUrl !== previewingUrl }"
								>
									{{ displayName!==null ? displayName.substring(0, 12) : name.substring(0, 12) }}
								</a>
								</div>
							</b-col>
							</b-row>
						</b-list-group-item>
						</FileManagerSubmitPacket>
					</div>
					</transition-group>
				</b-list-group>
				</b-form-checkbox-group>
			</div>
			</b-col>
		</b-row>

		<transition name="fade" mode="out-in">
			<b-row v-if="uploading">
				<b-col cols="12" class="my-2">
					<b-progress v-show="uploading" :max="100" height="2rem" animated striped>
						<b-progress-bar :value="uploadPercent" class="my-0">
							<h5 class="my-0">{{ uploadPercent.toFixed(0) }}%</h5>
						</b-progress-bar>
					</b-progress>
				</b-col>
			</b-row>
		</transition>
		<div :class="{'document-list-container': !previewing}">
    <loading-indicator v-if="loading && empty" class="my-5" />
    <div v-else-if="!empty || listSubmitResult.length > 0">
        <b-row no-gutters>
            <b-col v-if="showList" cols="12" :lg="previewing ? 12 : 12" :xl="previewing ? 12 : 12">
                <b-form-checkbox-group v-model="selected" name="selected">
                    <b-list-group :flush="flush">
						<div v-if="myAllResult.length > 0">
							<h5 style="font-size: 1rem; text-align: left; margin:5px; font-weight:bold"  v-if="!previewing">
								{{ !empty ? "Appeal Documents" : "" }}
							</h5>
							
							<b-row style="margin-right: 0px !important;" v-if="!previewing">
								<b-col cols="6" class="selectAllFiles">
									<!-- <input type="checkbox" id="checkbox" v-model="selectAllFiles"  @change="(checked) => changeFileSelection(checked, myAllResult, listSubmitResult)" style="transform: scale(1.2);"/> -->
									<input
									type="checkbox"
									:checked="selectAllFiles"
									@click="changeFileSelection($event, myAllResult)"
									style="transform: scale(1.2);"
									/>									
									<label for="checkbox" class="selectAllFilesLabel">{{ checkboxLabel }}</label>

									<button class="deleteAllAppealFilesBtn" @click="deleteSelectedFiles(myAllResult)" style="cursor: pointer;" v-if="selectAllFiles || selected.length >= 1">
										<i class="fas fa-trash text-danger" title="Delete Files"></i>
									</button>							
								</b-col>
							</b-row>
							<div class="selectedFileCount" v-if="!previewing">
								<span>
									<span v-if="selectedAppealFilesCount == myAllResult.length">
										<span style="color: grey;font-size: small;">All files selected</span>
									</span>
									<span v-else style="color: grey;font-size: small;margin-right:8px;">
										<span v-if="selectedAppealFilesCount >= 1">{{ selectedAppealFilesCount }} Selected out of </span>
										<span>
											{{ myAllResult.length }} 
											<span v-if="myAllResult.length == 1">File</span>
											<span v-else>Files</span>
										</span>
									</span>
								</span>
							</div>
							<transition-group name="fade" mode="out-in">
								<FileManagerItem
									v-for="(result, index) in myAllResult"
									:key="result.path"
									:prefix="prefix"
									:service="fileService"
									:value="result"
									ref="fileItems"
									:ref-in-for="true"
									:checked="result.checked"
									@update:checked="(val) => handleCheckboxChange(result, val)"
									v-slot="{
										canDelete,
										canDownload,
										canPreview,
										canRename,
										deleting,
										destroy,
										download,
										extension,
										fileName,
										isDirectory,
										lastModified,
										lastModifiedTimeAgo,
										mimeType,
										name,
										previewUrl,
										rename,
										renaming,
										size,
										checked,
										toggleChecked
									}"
									@deleted="deleted"
									@error="fileError($event)"
									@renamed="renamed"
								>
									<b-list-group-item :disabled="deleting" :active="previewUrl == previewingUrl" v-show="!previewing" class="mt-3">
										<b-row>
											<b-col cols="9" class="text-left">
												<b-row>
													<b-col cols="12" :md="12" :lg="12">
														<b-row>
															<b-col :cols="2" :lg="1">
																<b-form-checkbox :value="fileName" @change="toggleChecked"/>
																<!-- <b-form-checkbox :checked="result.checked" @change="toggleChecked"/> -->
																<!-- <b-form-checkbox
																	:checked="result.checked"
																	@change="(checked) => handleCheckboxChange(result, checked)"
																	:value="fileName"
																/> -->
															</b-col>
															<b-col :cols="10" :lg="11">
																<div v-if="deleting">Deleting...</div>
																<div v-else-if="!isDirectory" class="d-flex align-items-top">
																	<div></div>
																	<div>
																		<div>
																			<a
																				href="#"
																				v-if="canPreview"
																				@click.prevent="previewFile(fileName, previewUrl)"
																				class="font-weight-bold"
																				:class="previewUrl == previewingUrl ? 'text-white' : 'text-dark'"
																			>
																				{{ name }}
																			</a>
																			<span v-else>{{ name }}</span>
																		</div>
																		<div v-if="!previewing" class="d-flex">
																<div class="small text-muted">
																	<span v-if="extension">{{ extension }}</span>
																	<span v-if="extension && size">&middot;</span>
																	<span v-if="size">{{ size }}</span>
																</div>
																<div class="small text-muted ml-3">
																	<span>{{ lastModified.toLocaleDateString() }}</span>
																	&middot;
																	<span>{{ lastModifiedTimeAgo }}</span>
																</div>
															</div>
																	</div>
																</div>
																<div v-else-if="isDirectory" class="d-flex align-items-top">
																	<div>
																		<font-awesome-icon
																			icon="folder"
																			fixed-width
																			class="mr-4 text-muted"
																		/>
																	</div>
																	<div>
																		<div>
																			<a href="#">
																				{{ name }}
																			</a>
																		</div>
																	</div>
																</div>
															</b-col>
														</b-row>
													</b-col>
												
												</b-row>
											</b-col>
											<b-col cols="3" class="text-right">
												<b-button-group>
													<b-dropdown right variant="light">
														<template #button-content>
															<font-awesome-icon icon="cog" fixed-width />
														</template>
														<b-dropdown-item
															@click="download"
															:disabled="deleting || !canDownload"
														>
															Download
														</b-dropdown-item>
														<b-dropdown-item
															:href="previewUrl"
															target="_blank"
															:disabled="deleting || !canPreview"
														>
															Preview
														</b-dropdown-item>
														<b-dropdown-item
															@click="rename"
															:disabled="renaming || !canRename"
														>
															Rename
														</b-dropdown-item>
														<b-dropdown-divider />
														<b-dropdown-item
															variant="danger"
															@click="destroy"
															:disabled="deleting || !canDelete"
														>
															<font-awesome-icon icon="trash" />
															<span>Delete</span>
														</b-dropdown-item>
													</b-dropdown>
												</b-button-group>
											</b-col>
										</b-row>
									</b-list-group-item>
								</FileManagerItem>
							</transition-group>
						</div>
								<!-- user packet list start here on appeal docs -->
								<b-row v-if="!previewing">
									<b-col style="text-align: left;">
										<h5 style="font-size: 1rem; text-align: left; margin-top:40px; margin-left:4px; margin-bottom: 14px; font-weight:bold" v-if="!previewing">
											{{ listSubmitResult?.length>0 ? "User Packets" : "" }}
										</h5>
									</b-col>
									<b-col style="text-align:right;">
										<div style="margin-top:50px;margin-right:8px;color:gray" v-if="listSubmitResult.length > 0">
											<span v-if="listSubmitResult.length == 1">{{ listSubmitResult.length}} File</span>
											<span v-else>{{ listSubmitResult.length }} Files</span>
										</div>
									</b-col>
								</b-row>
								<transition-group name="fade" mode="out-in">
									<FileManagerSubmitPacket
										v-for="result in listSubmitResult"
										:key="result.filename"
										:prefix="prefix"
										:service="fileService"
										:value="result"
										v-slot="{
											canDelete,
											canDownload,
											canPreview,
											canRename,
											deleting,
											destroy,
											download,
											extension,
											fileName,
											isDirectory,
											lastModified,
											lastModifiedTimeAgo,
											mimeType,
											name,
											previewUrl,
											rename,
											renaming,
											size,
											displayName,
										}"
										@deleted="deleted"
										@error="fileError($event)"
										@renamed="renamed"
									>
									<b-list-group-item :disabled="deleting" :active="previewUrl == previewingUrl"
											v-if="!previewing" class="mt-1">
											<b-row>
												<b-col cols="9" md="8" xl="9" class="text-left">
													<b-row>
														<b-col cols="12" :md="12" :lg="12">
														<!-- <b-col cols="12" :md="previewing ? 12 : 7"
															:lg="previewing ? 12 : 7"> -->
															<b-row>
																<b-col :cols="2" :lg="1">
																	<b-form-checkbox
																	:value="fileName + '~PacketSubmit'" />
																</b-col>
																<b-col :cols="10" :lg="11">
																	<div v-if="deleting">Deleting...</div>
																	<div v-else-if="!isDirectory">
																		<div class="d-flex">
																			<!-- <div> <b-form-checkbox
																					:value="fileName + '~PacketSubmit'" />
																			</div> -->
																			<div>
																				<a href="#" v-if="canPreview"
																					@click.prevent="previewFile(fileName, previewUrl)"
																					class="font-weight-bold"
																					:class="previewUrl == previewingUrl ? 'text-white' : 'text-dark'">
																					{{ displayName !== null ?
																					displayName
																					: name }}
																				</a>
																				<span v-else>{{ name }}</span>
																			</div>
																		</div>
																		<div v-if="!previewing" class="d-flex">

																			<div class="small text-muted">
																				<span v-if="extension">{{ extension
																					}}</span>
																				<span v-if="extension && size">&middot;</span>
																				<span v-if="size">{{ size }}</span>
																			</div>
																			<div class="small text-muted ml-3">
																				<span>{{ formatDate(lastModified)
																					}}</span>
																				&middot;
																				<span>{{ lastModifiedTimeAgo }}</span>
																			</div>
																		</div>
																	</div>
																	<div v-else-if="isDirectory">
																		<font-awesome-icon icon="folder" fixed-width
																			class="mr-4 text-muted" />
																		<a href="#">{{ name }}</a>
																	</div>

																</b-col>
															</b-row>
														</b-col>
													</b-row>
												</b-col>
												<b-col cols="3" md="4" xl="3" class="text-right">
													<b-button-group>
														<b-dropdown right variant="light">
															<template #button-content>
																<font-awesome-icon icon="cog" fixed-width />
															</template>
															<b-dropdown-item @click="download"
																:disabled="deleting || !canDownload">
																Download
															</b-dropdown-item>
															<b-dropdown-item :href="previewUrl" target="_blank"
																:disabled="deleting || !canPreview">
																Preview
															</b-dropdown-item>
															<b-dropdown-item @click="rename"
																:disabled="renaming || !canRename">
																Rename
															</b-dropdown-item>
															<b-dropdown-divider />
															<b-dropdown-item variant="danger" @click="destroy"
																:disabled="deleting || !canDelete">
																<font-awesome-icon icon="trash" />
																<span>Delete</span>
															</b-dropdown-item>
														</b-dropdown>
													</b-button-group>
												</b-col>
											</b-row>

										</b-list-group-item>
									</FileManagerSubmitPacket>
								</transition-group>
							</b-list-group>
						</b-form-checkbox-group>
					</b-col>
					<b-col
						v-if="previewing"
						:cols="showList ? 12 : 12"
						:lg="showList ? 12 : 12"
						:xl="showList ? 12 : 12"
						class="text-right"
					>
						<PdfFrame :url="previewingUrl" />
					</b-col>
				</b-row>
			</div>
			<empty-result v-else icon="cloud-upload-alt">
				No documents uploaded
				<template #content> Drag and drop files to attach to this level. </template>
			</empty-result>
		</div>
	</FileManager>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import FileManager from "@/clients/components/Layout/file-manager.vue";
import FileManagerItem from "@/clients/components/Layout/file-manager-item.vue";
import FileManagerSubmitPacket from "@/clients/components/Layout/file-manager-submit-packet.vue";
import PdfFrame from "@/shared/components/PdfFrame.vue";

import * as AppealFileService from "@/clients/services/appealFiles";
import { event } from "jquery";

export default {
	name: "AppealFiles",
	components: {
		FileManager,
		FileManagerItem,
		FileManagerSubmitPacket,
		PdfFrame,
	},
	props: {
		id: {
			required: true,
			type: [Number, String],
			default: "",
		},
		flush: {
			type: Boolean,
			default: true,
		},
		showRefresh: {
			type: Boolean,
			default: false,
		},
		packetCreated: {
			type: Boolean,
			required: true
		},
		cancelSelection: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			fileService: AppealFileService,
			selected: [],
			previewing: false,
			previewingAppealFiles: true,
			previewingUrl: "",
			showList: true,
			submitted: '',
			myData: null,
			selectAllFiles: false,
			checkboxLabel: 'Select All Files',
			oldSelectedFiles: [],
			selectedAppealFilesCount: 0,
			resetCancelSelection: false

		};
	},
	computed: mapGetters({}),
	created() {},
	mounted() {},
	methods: {
		formatDate(date) {
			// Split the date by "/"
			const [day, month, year] = date.split('/');
			// Return in MM/DD/YYYY format
			return `${month}/${day}/${year}`;
		},
		refresh() {
			this.$refs.fileManager.refresh();
		},
		updateComponent(data) {
			this.refresh();

			this.myData = data;
		},
		filesLoaded(list) {
			this.selectAllFiles = false;
			this.updateSelectedFileCount();
			// this.selected = [];
			// Cancel previewing if going to display empty
			if (!list || list.length === 0) {
				this.previewing = false;
			}
			
		},
		async previewFile(fileName, previewUrl) {
			if (previewUrl === this.previewingUrl) {
				this.previewing = false;
				this.previewingUrl = "";
				this.previewingAppealFiles = true;
			} else {
				this.previewingAppealFiles = false;
				this.previewing = true;
				this.previewingUrl = previewUrl;
			}
		},
		mergedDocuments(data) {
			const fileCount = data.data.length || 0;
			this.selected = [];

			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Documents Merged",
				message: `${fileCount} file(s) merged into ${data.name}`,
			});
		},
		zippedDocuments(data) {
			const fileCount = data.data.length || 0;
			this.selected = [];

			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Documents Zipped",
				message: `${fileCount} file(s) zipped into ${data.name}`,
			});
		},
		fileError(event) {
			this.$store.dispatch("apiError", {
				error: event,
				title: "File Error",
				message: event.message || "Unable to complete file operation and no message was provided.",
			});
		},
		toggleList() {
			this.showList = !this.showList;
		},
		changeFileSelection(event, files){
			const willBeChecked = !this.selectAllFiles;
			const filePaths = [];
			if(this.packetCreated){
				if (!confirm("Are you sure you want to select/deselect files? It will delete the existing packet.")) {
					event.preventDefault();
					this.selectAllFiles = false;
					this.$emit("update:selected", this.selected);
					// this.cancelSelection = true;
					this.$emit('update-cancel-selection', true);
					return;
				}else{
					this.selected = [];
					this.selectAllFiles = willBeChecked;
					this.cancelSelection = false;
					this.$emit('update-cancel-selection', false);
					files.forEach(file => {
						filePaths.push(file.path);
						this.selected.push(file.path.replace(/^[^/]+\//, ""));
					});
					this.checkboxLabel = willBeChecked ? 'Deselect All Files' : 'Select All Files';
					this.$emit('update:selected', willBeChecked ? filePaths : []);
					this.updateSelectedFileCount();
					this.$emit('destroy-packet');
				}
			}else{

				// check if selected file array includes user packet file
				const hasPacketSubmit = this.selected.some(item => item.includes("~PacketSubmit"));
				// if user packet exists, remove all appeal Files and keep only user packet file in the selected array
				if(hasPacketSubmit){
					this.selected = this.selected.filter(item => item.includes("~PacketSubmit"));
				}else{
					this.selected = [];
				}

				// get all file path and push all the appeal file names into selected array
				// user tries to select all files
				if(willBeChecked){
					files.forEach(file => {
						files.checked = true;
						filePaths.push(file.path);
						this.selected.push(file.path.replace(/^[^/]+\//, ""));
					});
				}
				this.updateSelectedFileCount();
				this.selectAllFiles = willBeChecked;	
				this.checkboxLabel = !this.selectAllFiles ? 'Select All Files' : 'Deselect All Files';
				this.$emit('update:selected', this.selectAllFiles ? filePaths : []);
			}	
		},
		deleteSelectedFiles(files) {
			// check if there is any current existing packet first
			if(this.packetCreated){
				if(!confirm("Packet already exists. Deleting selected file will delete the existing packet.")) return;
			}else{
				if (!confirm("Are you sure you want to delete all selected files?")) return;
			}
			
			if(this.selectAllFiles){
				this.selected.forEach((selectedFileName) => {
					// Find the file component whose fileName matches the selected file name
					const fileComponent = this.$refs.fileItems.find(
						(item) => item.fileName === selectedFileName
					);

					if (fileComponent) {
						fileComponent.destroy({ silent: true });
					}
				});
			}else{
				this.selected.forEach((selectedFileName) => {
					// Find the file component whose fileName matches the selected file name
					const fileComponent = this.$refs.fileItems.find(
						(item) => item.fileName === selectedFileName
					);

					if (fileComponent) {
						fileComponent.destroy({ silent: true });
					}
				});
			}
			
			this.checkboxLabel = 'Select All Files';
			this.selectAllFiles = false;
			const hasPacketSubmit = this.selected.some(item => item.includes("~PacketSubmit"));
			if(hasPacketSubmit){
				this.selected = this.selected.filter(item => item.includes("~PacketSubmit"));
			}
			// this.selected = [];
			this.$emit('update:selected', []);
		},
		onCheckboxChange(event, result) {
			// TODO: THIS METHOD SEEMS REDUNDANT. REMOVE IF NEVER USED
			// Additional logic here
			result.checked = event;
			console.log('Checkbox toggled:', result.fileName, 'Checked:', result.checked);
		},
		handleCheckboxChange(result, checked) {
			this.updateSelectedFileCount();
			if (this.packetCreated && this.cancelSelection) {
					result.checked = false;
					const index = this.selected.indexOf(result.path.split("/").pop().split("~")[0]);
					if (index !== -1) {
						this.selected.splice(index, 1);
					}
					this.updateSelectedFileCount();
					
			}else if (this.packetCreated && !this.cancelSelection){
				this.$emit('destroy-packet');
			}
			result.checked = true;
		},
		setSelectedAppealFileCountToZero(){
			// this method is called by parent(view_appel.vue) to set selected Appeal files to 0
			this.selectedAppealFilesCount = 0;
		},
		updateSelectedFileCount(){
			this.selectedAppealFilesCount = this.selected.length - (this.selected.filter(item => item.includes("~PacketSubmit")).length);
		}

	},
	destroyed() {},
	watch: {
		previewing(val) {
			if (!val) {
				this.previewingUrl = "";
			}
		},
		selected: {
			handler(newVal, oldVal) {
				if(this.packetCreated && !this.resetCancelSelection){
					this.cancelSelection = false;
				}
				if(this.packetCreated && !this.cancelSelection && !this.resetCancelSelection){
					if (!confirm("Are you sure you want to select/deselect files? It will delete the existing packet.")) {
						this.cancelSelection = true;
						this.$emit('update-cancel-selection', true);
						this.resetCancelSelection = true;
						return false;
					}
				}

				// below condition is to handle the cancel the current select/deselect
				if(this.packetCreated && this.cancelSelection && this.resetCancelSelection){
					// this.$emit("update:selected", oldVal);
					this.cancelSelection = false;
					this.$emit('update-cancel-selection', false);
					this.resetCancelSelection = false;
					return;
				}

				if(this.packetCreated == false || (this.packetCreated && this.cancelSelection == false)){
					this.$emit("update:selected", newVal);
				}else{
					this.cancelSelection = false;
					this.$emit('update-cancel-selection', false);
					this.resetCancelSelection = false;
					this.$emit("update:selected", oldVal);
				}
			},
			// deep: true
		},
		packetCreated(newVal) {
			if (newVal) {
			console.log("Packet was created.");
			} else {
			console.log("Packet was destroyed.");
			}
		},
		myData(val) {
			if (val) {
			this.previewing = false;
			}
		},
	},
};
</script>
<style>
.horizontal-scroll-container {
  overflow-x: auto; /* Enable horizontal scrolling */
  white-space: nowrap; /* Prevent wrapping of content */
}

.horizontal-scroll-list {
  display: inline-block; /* Make the list items display inline */
  white-space: nowrap; /* Prevent list items from wrapping */
}

.horizontal-scroll-list .list-group-item {
  display: inline-block; /* Make each item display inline */
}

.document-list-container {
  max-height: 750px; /* Adjust the height as needed */
  overflow-y: clip;
  overflow-x: clip;
}
.selectAllFiles {
	font: bold;
	font-size: 12px;
	color: black;
	margin-left: 21px;
	margin-top: 14px;
}
.selectAllFilesLabel {
	vertical-align: middle;
	margin-left: 8px;
}
.deleteAllAppealFilesBtn{
	border: none;
    border-left: 2px solid #cbcbcb;
    background: none;
    margin-left: 8px;
    vertical-align: text-bottom;
}
.selectedFileCount {
	margin-bottom: -16px;
	text-align: right;
	font-size:xx-small;
	margin-right: 8px;
}

</style>
